// this is an autogenerated file from DesignSystem/ManualAutomations/Content/Content/ActiveAction/TaskInsertNew/Stage/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ManualAutomations_Content_Content_ActiveAction_TaskInsertNew_Stage($board_id: uuid!) {
  tasks_stages(
    where: { board_id: { _eq: $board_id } }
    order_by: { order: asc }
  ) {
    id
    text: name
    order
    done
  }
}

`